/**
 * Restaurant Priority store
 */
window.$(".saverestaurantsPriority").on('click', function (e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.axios({
        method: "post",
        url: window.$(".restaurantPriorityForm").attr('action'),
        data: window.$(this).closest(".restaurantPriorityForm").serialize(),
    })
        .then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            window.$(this).removeAttr('disabled');

        })
        .catch(function (error) {
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.toastr.error(error.response.data.message);

                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message);
            }
        });
    return false;
});